module.exports = __webpack_public_path__ + "img/j_flu.94c38193.jpg";